<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpdateUI = true;
      });
    }
  },
  methods: {
    async accept() {
      this.showUpgradeUI = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    }
  }
};
</script>



<style lang="scss">
body {
  overflow-x: hidden;
}
.wrapper-content {
  width: 100%;
}
.header-dashboard {
  width: 100%;
}
.header-dashboard1 {
  width: 100%;
}
.panel {
  display: inline-block;
  width: 100%;
}
#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.header-dashboard {
  left: 320px;
  right: 0px;
}
.header-left {
  cursor: pointer;
}

.sidebar-sticky.active + .wrapper-content {
  margin-left: 0;
}
.sidebar-sticky + .wrapper-content {
  margin-left: 320px;
  /*padding-top: 90px;*/
  width: 100%;
  position: inherit;
}

.sidebar-sticky.active {
  margin-left: -320px;
}
.errorText {
  h1 {
    font-size: 50px;
    font-weight: bold;
  }
  p {
    font-size: 20px;
  }
}
.btn.btn-primary.backHomeBtn {
  background: #2c3e50 !important;
  border-color: #2c3e50 !important;
  border-radius: 30px;
  padding: 10px 30px;
  margin-top: 30px;
}
</style>
